import { withTranslation } from "next-i18next";
import catalogContexts from "@utils/constants/catalogContexts";

function SalesRibbon({ context, t }) {
  if (context !== catalogContexts.sales) return null;

  const salesText = Array.from({ length: 30 }, (_, index) => [
    <span key={`sales-${index}`}>{t("common:navbar.sales")}</span>,
    <span key={`sep-${index}`}>{"//"}</span>,
  ]);

  return (
    <div className="bg-tertiary context-sales-ribbon">
      <span className="h6 mb-0 text-center text-uppercase text-white d-flex gap-3">
        {salesText}
      </span>
    </div>
  );
}

export default withTranslation("common")(SalesRibbon);
